import * as Fetch from '@/helpers/fetch'

export const getCampaigns = async (token: string): Promise<Fetch.HttpResponse> => {
  const url = `${process.env.VUE_APP_CAMPAIGN_BFF_URL}/v1/campaigns`
  const options = {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
      'channel': 'line'
    },
  }
  try {
    const result = await Fetch.get(url, options)
    return result
  } catch (error) {
    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}